import { ref } from 'vue';
import { ZoomPhoneResultApiService } from '@/api/user/resources/zoom_phone_result';
import { formatISO8601InMinute } from '@/utils/date-time';

const useZoomPhoneResultPrevNext = (
  getCurrentId: () => number | null,
  getCurrentQuery: () => Record<string, string> | null,
) => {
  const prevId = ref<number | null>(null);
  const nextId = ref<number | null>(null);
  const prevPage = ref<number | null>(null);
  const nextPage = ref<number | null>(null);
  const loading = ref(false);

  const refresh = async () => {
    prevId.value = null;
    nextId.value = null;
    prevPage.value = null;
    nextPage.value = null;

    const currentId = getCurrentId();
    if (currentId == null) return;

    const getConvertedCurrentQuery = () => {
      const currentQuery = getCurrentQuery();
      return {
        startedAtFrom: currentQuery?.startedAtFrom === 'all' ? undefined : formatISO8601InMinute(currentQuery?.startedAtFrom),
        startedAtTo: currentQuery?.startedAtTo === 'all' ? undefined : formatISO8601InMinute(currentQuery?.startedAtTo),
        callerUserId: currentQuery?.callerUserId === 'all' ? undefined : currentQuery?.callerUserId,
        calleeDidNumber: currentQuery?.calleeDidNumber,
        durationFrom: currentQuery?.durationFrom === undefined ? undefined : Number(currentQuery.durationFrom),
        durationTo: currentQuery?.durationTo === undefined ? undefined : Number(currentQuery.durationTo),
      };
    };

    const api = new ZoomPhoneResultApiService();
    loading.value = true;
    try {
      const { data } = await api.getZoomPhoneResultNeighbors({ request: { id: currentId, ...getConvertedCurrentQuery() } });
      prevId.value = data.prevId ?? null;
      prevPage.value = data.prevPage ?? null;
      nextId.value = data.nextId ?? null;
      nextPage.value = data.nextPage ?? null;
    } finally {
      loading.value = false;
    }
  };

  return {
    prevId,
    nextId,
    prevPage,
    nextPage,
    loading,
    refresh,
  };
};

export {
  useZoomPhoneResultPrevNext,
};
